export function resolvePublicApiUrl(
	apiUrl: string | undefined,
	apiUrlSSR: string | undefined,
	isServer = import.meta.server,
): string {
	return (isServer ? apiUrlSSR || apiUrl : apiUrl) || '';
}
